// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./components/App.vue";
import router from "./routes";
import { attachValidation } from "@/shared/validation";
import VModal from "vue-js-modal";
import { registerGtm } from "@/shared/pinia-gtm";
import { VueMaskDirective } from "v-mask";
import { suppressRouterNavigationErrors } from "@/shared/routerHelper";

Vue.directive("mask", VueMaskDirective);

import { registerComponents } from "@bend-financial/styleguide";

registerComponents(Vue);
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);

import "@bend-financial/styleguide/dist/styleguide.css";

import UniqueId from "vue-unique-id";

Vue.use(UniqueId);

// Include slider CSS
import "swiper/dist/css/swiper.min.css";
import VueCompositionAPI from "@vue/composition-api";

Vue.use(VueCompositionAPI);

import {
    createPinia,
    PiniaVuePlugin
} from "pinia";

Vue.use(PiniaVuePlugin);

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
pinia.use(({ store }) => {
    store.router = router;
});

Vue.prototype.$bendAppOptions = {
    validGroups: [ "employee", "BEND-Employee-User" ],
    site: "EMPLOYEE"
};
import Router from "vue-router";

attachValidation();

suppressRouterNavigationErrors(Router);

Vue.use(Router);

Vue.config.productionTip = false;

Vue.use(VModal);

import { AuthFactory }  from "@/shared/api/auth";
import oktaConfig from "@/okta-config";
import cognitoConfig from "@/cognito-config";
AuthFactory.init(cognitoConfig.employee, oktaConfig.employee);

registerGtm(router);

/* eslint-disable no-new */
// tslint:disable-next-line:no-unused-expression
const app = new Vue({
    el: "#app",
    template: "<App/>",
    components: { App },
    router,
    pinia
});